import React, { Component } from 'react';
import { HttpRequestService } from '../services/HttpRequestService';

class OrderTypesSelect extends Component {

    constructor(props) {
        super(props);
        this.state = { orderTypes: [] };
        this.getOrderTypes = this.getOrderTypes.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.http = new HttpRequestService();
    }

    componentDidMount() {
        this.getOrderTypes();
    }

    componentWillUnmount() {

    }

    getOrderTypes() {
        this.http.get('/api/Orders/GetOrderTypes', null).then(data=>{
            this.setState({ orderTypes: data });
        });
    }

    handleChange(e) {
        this.props.onChange(e.target.value);
    }

    render() {
        var options = this.state.orderTypes.map((item) =>
            <option key={item.key} value={item.key}>{item.value}</option>
        );

        return (
            <select className="form-control" value={this.props.value} onChange={this.handleChange}>
                {this.props.hasAllOption === true &&
                    <option value="-1">-- ALL --</option>
                }
                {options}
            </select>
        );
    }
}
export default OrderTypesSelect